import { useCallback } from 'react';
import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';
import { fireTrackAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';

export const IneligibilityReasons = {
	OPTED_OUT: 'opted-out',
	NO_ELIGIBLE_INVITEES: 'no-eligible-invitees',
	MISSING_INVITE_CAPABILITY: 'missing-invite-capability',
	ELIGIBLE: 'eligible',
} as const;

export type IneligibilityReasons = (typeof IneligibilityReasons)[keyof typeof IneligibilityReasons];

type Attributes = {
	product: string;
	isSameSite: boolean;
};

export const useFeatureExposedV2 = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return useCallback(
		(ineligibilityReason: IneligibilityReasons, attributes: Attributes) => {
			const isIneligible = ineligibilityReason !== IneligibilityReasons.ELIGIBLE;
			const [expConfig] = UNSAFE_noExposureExp('invite_prompt_on_link_insert_v2');
			const cohort = isIneligible ? 'not-enrolled' : expConfig.get('cohort', 'not-enrolled');
			fireTrackAnalytics(createAnalyticsEvent({}), 'feature exposed', {
				flagKey: 'invite_prompt_on_link_insert_v2',
				cohort,
				ineligibilityReason,
				...attributes,
			});
		},
		[createAnalyticsEvent],
	);
};
